<template>
  <div class="description-item">
    <div
      class="label"
      :style="{
        width: `${size}em`,
        'margin-right': `${space}`,
      }"
    >
      {{ label }}
    </div>
    <div class="value">
      <slot>{{ value }}</slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { defineProps, withDefaults } from 'vue';

  withDefaults(
    defineProps<{
      label: string;
      value?: string;
      size?: number;
      space?: string;
    }>(),
    {
      size: 4,
      space: '8px',
    },
  );
</script>

<style lang="scss" scoped>
  .description-item {
    display: flex;
    align-items: center;
    font-size: 16px;

    & + & {
      margin-top: 8px;
    }

    .label {
      font-size: 16px;
      color: rgba(0, 27, 81, 0.6);
      text-align: left;
    }
    .value {
      font-size: 16px;
      color: #001b51;
      font-weight: 500;
    }
  }
</style>
